import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { TutorialModal } from "@/components/HelpButton";
import { PAGE, CARD } from "@/lib/styles";
import { GraduationCap, Play, ChevronRight, Loader2 } from "lucide-react";

export default function Tutoriales() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/tutorials").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className={`${PAGE} font-body`}>
      <Navbar />
      <div className="max-w-5xl mx-auto p-6 md:p-10" data-testid="tutoriales-page">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-2xl bg-indigo-600/10 text-indigo-500 flex items-center justify-center"><GraduationCap size={26} /></div>
          <div>
            <h1 className="font-heading font-light text-4xl sm:text-5xl tracking-tight">Tutoriales</h1>
            <p className="font-mono2 text-xs text-slate-500 dark:text-slate-400 mt-1">Aprende a usar cada herramienta de Notacora</p>
          </div>
        </div>

        {loading ? (
          <div className="py-20 flex justify-center text-slate-400"><Loader2 className="animate-spin" size={26} /></div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((t) => (
              <button key={t.tool} onClick={() => setActive(t.tool)} className={`${CARD} p-5 text-left group`} data-testid={`tutorial-card-${t.tool}`}>
                <div className="w-10 h-10 rounded-lg bg-indigo-500/10 text-indigo-500 flex items-center justify-center mb-3 group-hover:scale-105 transition-transform"><Play size={18} /></div>
                <p className="font-heading font-medium text-base mb-1">{t.title}</p>
                <p className="font-body text-sm text-slate-500 dark:text-slate-400 line-clamp-2">{t.description}</p>
                <span className="inline-flex items-center gap-1 text-indigo-500 text-xs font-medium mt-3">Ver tutorial <ChevronRight size={13} /></span>
              </button>
            ))}
          </div>
        )}
      </div>
      <TutorialModal tool={active} open={!!active} onClose={() => setActive(null)} />
    </div>
  );
}
